class ValidationError extends Error {
  constructor(message, key) {
    super(message); // (1)
    this[key] = message;
  }
}

export default ValidationError;



// WEBPACK FOOTER //
// ./src/utility/ValidationError.js